import React from 'react';
import ReactDOM from 'react-dom';
import { Home } from './pages/home';

import * as serviceWorker from './serviceWorker';
import { FormProvider } from './store/MLI/MLIContext';
import { StepperProvider } from './store/stepper/StepperContext';

import './styles/main.scss';

import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Appointement } from './pages/appointement';
import { ThankYou } from './pages/thankyou';

export const getBasename = () => {
    const name = window.location.pathname.split('/')[1] || '/';
    return `${name === '/' ? name : `/${name}`}`;
};

ReactDOM.render(
    <React.StrictMode>
        <StepperProvider>
            <FormProvider>
                <Router basename={getBasename()}>
                    <Switch>
                        <Route exact path="/">
                            <Home />
                        </Route>
                        <Route path="/afspraak">
                            <Appointement />
                        </Route>
                        <Route path="/bedankt">
                            <ThankYou />
                        </Route>
                        <Route path="*" render={() => <Redirect to="/" />} />
                    </Switch>
                </Router>
            </FormProvider>
        </StepperProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
